<template>
  <el-dialog
    width="400px"
    :visible.sync="userEditDialogVisi"
    :before-close="close"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
  >
    <el-row type="flex" justify="center">
      <el-col :span="14">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item :label="$t('profile.avatar')">
            <div style="display: inline-block">
              <CustomUploader
                ref="MyUploader"
                v-model="form.tenementUserAvatar"
                :url="form.tenementUserAvatarUrl"
                :is-circle="true"
                file-type="tenementUserAvatarImg"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('profile.name')" prop="tenementUserName">
            <el-input
              v-model="form.tenementUserName"
              clearable
              placeholder="请输入用户名称"
            />
          </el-form-item>
          <el-form-item :label="$t('profile.email')">
            <el-input v-model="form.email" clearable placeholder="请输入邮箱" />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">
        {{ $t('profile.back') }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="formOnSubmit('form')"
      >{{ $t('profile.updateProfile') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { updateUser } from '@/api/user'
export default {
  components: {},
  props: {},
  data() {
    return {
      submitLoading: false,
      form: { tenementUserName: '', email: '' },
      rules: {
        tenementUserName: [
          {
            required: true,
            message: this.$t('profile.namePlaceholder'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userEditDialogVisi: (state) => state.user.userEditDialogVisi,
      roleList: (state) => state.permission.roleList
    })
  },
  watch: {
    userEditDialogVisi(val) {
      if (val) {
        this.form.tenementUserAvatar = ''
        this.form.tenementUserAvatarUrl = this.$store.state.user.userInfo
          .tenementUserAvatarPath
          ? process.env.VUE_APP_OSS_DOMAIN +
            '/' +
            this.$store.state.user.userInfo.tenementUserAvatarPath
          : ''
        this.form.tenementUserName =
          this.$store.state.user.userInfo.tenementUserName
        this.form.email = this.$store.state.user.userInfo.email
        this.form.tenementUserId =
          this.$store.state.user.userInfo.tenementUserId
      } else {
        this.form.tenementUserAvatarUrl = ''
      }
    }
  },
  methods: {
    close() {
      this.$store.dispatch('user/setUserEditDialogVisi', false)
      this.$refs.MyUploader.clear()
    },
    formOnSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSubmit() {
      this.submitLoading = true
      const form = Object.assign({}, this.form)
      form.roleIdList = this.roleList.map((item) => item.roleId)
      if (form.tenementUserAvatar) {
        const arr = form.tenementUserAvatar.split(',')
        form.tenementUserAvatarAttachId = arr[1]
        form.tenementUserAvatarPath = arr[0]
      }
      updateUser(form)
        .then((res) => {
          this.$message.success(res.message)
          this.$store.dispatch('user/getUserInfo')
          this.$store.dispatch('user/setUserEditDialogVisi', false)
        })
        .finally(() => {
          this.submitLoading = false
        })
    }
  }
}
</script>

<style scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-form-item__label {
  float: none;
}

.ImageBox {
  display: flex;
  justify-content: center;
}
</style>
